<div class="stations-select-container">
  <app-dropdown
    [options]="(stationView$ | async) || []"
    [valueFormControl]="valueFormControl"
    [isMultiSelect]="true"
    [showToggleAll]="true"
    [fieldPlaceholder]="'export-creation.form.selectStations.placeholder' | translate">
  </app-dropdown>

  @if (showCheckbox) {
    <app-checkbox
      [formControl]="showAllStationsForm"
      [label]="'export-creation.form.selectStations.showAllStations' | translate"
      (change)="update($event)"
    ></app-checkbox>
  }

  @if (excludeStations?.length && !showAllStationsForm.value) {
    <i class="fa-solid fa-triangle-exclamation" (click)="op.toggle($event)"></i>
  }
</div>

<p-popover #op>
  <div class="custom-station-po">
    <div class="custom-station-po-title">
      {{ 'export-creation.form.selectStations.excludeStationsOp.title' | translate : { count: excludeStations?.length ?? 0 } }}
    </div>
    <div class="custom-station-po-items ">
      <ul>
        @for (station of excludeStations; track station.value) {
          <li class="px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 hover:bg-gray-100 transition">
            {{ station.label }}
          </li>
        }
      </ul>
    </div>
  </div>
</p-popover>
